module.exports = __webpack_public_path__ + "img/pr-4.e55d6f4e.png";